"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Patcher_1 = require("../Patcher");
class Handler {
    constructor(sourceType, name) {
        this.sourceType = sourceType;
        this.name = name;
    }
    matches(obj, prop) {
        return this.name === prop && obj instanceof this.sourceType;
    }
    handle(obj, settings) {
        const value = obj[this.name];
        if (!settings) {
            obj[this.name] = undefined;
        }
        else {
            Patcher_1.Patcher.patchObject(value, settings);
        }
    }
}
exports.Handler = Handler;
//# sourceMappingURL=Handler.js.map